import { render, staticRenderFns } from "./CareOfChildCalculation.vue?vue&type=template&id=22da6bb9"
import script from "./CareOfChildCalculation.vue?vue&type=script&lang=js"
export * from "./CareOfChildCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports